module.exports = __webpack_public_path__ + "img/loogo-.5e525dc6.png";